import * as React from 'react';
import { Container, Title, Section, VariantSlider } from '../../modules/modules';
import GetLastVisitedQuery from '../Query/Products/LastVisited';
import CountryService from '../../services/CountryService';
import GoogleTagManagerService from '../../services/GoogleTagManagerService';

interface ILastVisitedProps {
  without?: string;
  GTMItemListName?: string;
}

class LastVisited extends React.Component<ILastVisitedProps> {

  public render() {
    const { countryId } = CountryService.GetInstance();

    return (
      <GetLastVisitedQuery
        without={this.props.without || null}
        country={countryId}
        limit={20}
      >
        {({ lastVisited }: any) => {
          if (lastVisited && lastVisited.lastVisited) {
            const variants = lastVisited.lastVisited.map((lisited: GQL.ILastVisited) => {
              return lisited.variant;
            });

            GoogleTagManagerService.productsInCategory(variants, {
              pageType: 'product',
              list: 'lastvisited',
              itemListName: 'Last Visited',
            });

            return (
              <Section type="last-visited">
                <Container>
                  <div className="last-visited">
                    <Title type="center">Last visited</Title>
                    <VariantSlider
                      variants={variants}
                      productTags={lastVisited.productTags}
                      GTMItemListName={this.props.GTMItemListName}
                    />
                  </div>
                </Container>
              </Section>
            );
          }

          return null;
        }}
      </GetLastVisitedQuery>
    );
  }
}

export default LastVisited;



// WEBPACK FOOTER //
// ./src/components/LastVisited/LastVisited.tsx